import { CameraType } from "APP_ROOT/data/media";
export default {
  name: "cellphone_detection",
  localization: {
    en: {
      title: "Cellphone detected",
      settingsHeader: "Cellphone Detection",
    },
    fr: {
      title: "Cellulaire détecté",
      settingsHeader: "Détection de Cellulaire",
    }
  },
  proto: {
    name: "EVENT_RAVEN_CELLPHONE_DETECTED",
    value: 129
  },
  isBuiltByDefault: true,
  isBuiltEnvironmentOverride: {
    showcase: false,
  },
  visibility:{
    reports: true,
    coaching: true,
    coachingNoFacialRecognition: true,
    warning: true,
  },
  isConsumerFeature: false,
  defaultCameraType: CameraType.CAMERA_CABIN,
  showBetaDecoration: false,
}